import { render, staticRenderFns } from "./PlaceHolderCircles.vue?vue&type=template&id=6df0966a&scoped=true"
import script from "./PlaceHolderCircles.vue?vue&type=script&lang=ts"
export * from "./PlaceHolderCircles.vue?vue&type=script&lang=ts"
import style0 from "./PlaceHolderCircles.vue?vue&type=style&index=0&id=6df0966a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0966a",
  null
  
)

export default component.exports